export class AppError extends Error {
  status: number;

  constructor(message: string = "An unexpected error occurred.") {
    super(message);
    this.name = "AppError";
    this.status = 500;
    Object.setPrototypeOf(this, AppError.prototype);
  }
}
